module.exports = __webpack_public_path__ + "e90e35c6eabff2c31a824e21a69785a5.ttf";